import React from 'react';
import Icon from '../../../Symbols/Icon';
const IconSplitSave = ({ size, fill, ...commonProps }) => {
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.1732 12.0423C20.1732 15.3271 18.3643 17.1361 15.0794 17.1361H9.98561L13.3815 6.94849H20.1732V12.0423ZM8.29173 5.25C4.0469 5.25 1.5 7.7969 1.5 12.0417V18.8335H15.0835C19.3283 18.8335 21.8752 16.2866 21.8752 12.0417V5.25H8.29173Z", fill: "#192325" }))),
        alt: 'Split save',
    };
    return React.createElement(Icon, { ...commonProps, source: iconContent, size: size, fill: fill });
};
IconSplitSave.displayName = 'IconSplitSave';
export default IconSplitSave;
//# sourceMappingURL=index.js.map